import { AxiosError } from 'axios';

/**
 * Determines if an error is a connection error (backend is unreachable)
 * @param error - The axios error to check
 * @returns true if the error indicates the backend is unreachable
 */
export function isConnectionError(error: AxiosError | any): boolean {
  if (!error) return false;

  // Check for network errors (ECONNREFUSED, etc.)
  if (error.code === 'ECONNREFUSED') {
    return true;
  }

  // Check for timeout errors
  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    return true;
  }

  // No response means the request was made but no response received
  // This typically indicates the server is down
  if (error.isAxiosError && !error.response && error.request) {
    return true;
  }

  return false;
}

/**
 * Gets the translation key for connection errors
 * @param error - The error to get translation key for
 * @returns A translation key for the error message
 */
export function getConnectionErrorKey(error: AxiosError | any): string {
  if (error.message?.includes('timeout') || error.code === 'ECONNABORTED') {
    return 'app.request_tracking.errors.connection.timeout';
  }

  return 'app.request_tracking.errors.connection.unable_to_connect';
}
